// Public /resources page — wraps the shared KnowledgeBaseShell with the
// top brand Navigation so logged-out visitors get a consistent header.
import Navigation from "../components/Navigation";
import KnowledgeBaseShell from "../components/KnowledgeBaseShell";

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <Navigation />
      <KnowledgeBaseShell mode="public" />
    </div>
  );
}
